import React from "react";
import "../styles/Contact.css";
import handleSubmit from "../components/handleSubmit"; // Make sure this is correctly imported

const Contact = () => {
  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        {/* Left - Contact Info */}
        <div className="contact-left">
          <h2>
            Get In <span className="highlight">Touch</span>
          </h2>
          <p className="description">
            Have questions about our services or ready to start your automation project? Contact us today and our team will get back to you promptly.
          </p>

          <div className="contact-info">
            <div className="info-block">
              <div className="dot"></div>
              <div>
                <p className="info-title">Our Location</p>
                <p className="info-description">
                  201H, Gupta Building, 2nd floor, Near Hotel S3, Badlapur-Kalyan Road, Empire Industrial Centrum, Ambarnath(W), 421 501.
                </p>
              </div>
            </div>

            <div className="info-block">
              <div className="dot"></div>
              <div>
                <p className="info-title">Phone</p>
                <p className="info-description">+91 9359685605</p>
              </div>
            </div>

            <div className="info-block">
              <div className="dot"></div>
              <div>
                <p className="info-title">Email</p>
                <p className="info-description">rkindustrialautomation@outlook.com</p>
                <p className="info-description">rkautomation56@gmail.com</p>
              </div>
            </div>

            <div className="social-icons">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="social-circle"></div>
              ))}
            </div>
          </div>
        </div>

        {/* Right - Contact Form */}
        <div className="contact-form-wrapper">
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="fullName">Full Name</label>
                <input id="fullName" name="fullName" type="text" placeholder="John Doe" required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input id="email" name="email" type="email" placeholder="you@example.com" required />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="companyName">Company Name</label>
              <input id="companyName" name="companyName" type="text" placeholder="Your Company" />
            </div>

            <div className="form-group">
              <label htmlFor="service">Service of Interest</label>
              <select id="service" name="service" defaultValue="">
                <option value="" disabled>-- Select a Service --</option>
                <option value="PLC Programming">PLC Programming</option>
                <option value="SCADA Integration">SCADA Integration</option>
                <option value="Industrial Automation">Industrial Automation</option>
                <option value="Other">Need On Site Support</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" rows="4" placeholder="Tell us about your project"></textarea>
            </div>

            <button type="submit" className="submit-button">Send Message</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
